<div class="error-container">
  <h1 class="error-text">{{ data.text }}</h1>
</div>
